import { Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";

import {
  AuthDataWrapper,
  BusinessUnitDataWrapper,
  LayoutDataWrapper,
  PersonalDataWrapper,
} from "components/DataWrapper";
import CorporationDataWrapper from "components/DataWrapper/Corporation";
import { ErrorWrapper } from "components/Error";
import Layout from "components/Layout";
import PageLoader from "components/Layout/PageLoader";
import {
  AccessRoute,
  AuthRoute,
  LayoutRoute,
  RedirectRoute,
} from "components/Route";
import { routes } from "./routes";

const MainElement = () => {
  return (
    <ErrorWrapper fullPage>
      <LayoutDataWrapper>
        <AuthDataWrapper>
          <Layout>
            <BusinessUnitDataWrapper>
              <CorporationDataWrapper>
                <PersonalDataWrapper>
                  <Suspense fallback={<PageLoader />}>
                    <Outlet />
                  </Suspense>
                </PersonalDataWrapper>
              </CorporationDataWrapper>
            </BusinessUnitDataWrapper>
          </Layout>
        </AuthDataWrapper>
      </LayoutDataWrapper>
    </ErrorWrapper>
  );
};

const router = createBrowserRouter([
  {
    element: <MainElement />,
    children: routes.map((route) => ({
      path: route.path,
      element: (
        <LayoutRoute route={route}>
          <RedirectRoute route={route}>
            <AuthRoute route={route}>
              <AccessRoute route={route}>{route.element}</AccessRoute>
            </AuthRoute>
          </RedirectRoute>
        </LayoutRoute>
      ),
    })),
  },
]);

export default router;
